import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './contactUsForm.css';

const translations = {
  es: {
    contact: {
      title: "Cotice con nosotros",
      name: "Nombre",
      email: "Correo electrónico",
      phone: "Número de teléfono",
      message: "Mensaje",
      send: "Enviar",
      sent: "Mensaje enviado!"
    }
  },
  en: {
    contact: {
      title: "Get a Quote for our products",
      name: "Name",
      email: "Email",
      phone: "Phone Number",
      message: "Message",
      send: "Send",
      sent: "Message sent!"
    }
  }
};

function ContactUsForm({ lang }) {
  const t = translations[lang] || translations.en;
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    emailjs.send(
      'service_zz7oqhq',
      'template_6278cdr',
      form,
      'v30CzqahwBgcPrfv7'
    ).then(() => {
      setSent(true);
      setForm({ name: '', email: '', phone: '', message: '' });
    }, (error) => {
      alert('Failed to send message, please try again.');
    });
  };

  return (
    <section className="contact-us" id="contact">
      <h2>{t.contact.title}</h2>
      <form className="contact-form" onSubmit={handleSubmit}>
        <input type="text" name="name" placeholder={t.contact.name} value={form.name} onChange={handleChange} required />
        <input type="email" name="email" placeholder={t.contact.email} value={form.email} onChange={handleChange} required />
        <input type="text" name="phone" placeholder={t.contact.phone} value={form.phone} onChange={handleChange} required />
        <textarea name="message" placeholder={t.contact.message} value={form.message} onChange={handleChange} required rows={4}></textarea>
        <button type="submit">{t.contact.send}</button>
        {sent && <p style={{ color: 'green' }}>{t.contact.sent}</p>}
      </form>
      <div className="contact-info">
        <div>
          <span>Email:</span>
          <a href="mailto:camitexcr@gmail.com" style={{ color: "#222", textDecoration: "none", fontWeight: 600 }}>
            camitexcr@gmail.com
          </a>
        </div>
        <div>
          <span>Tel:</span>
          <a href="tel:+50625373281" style={{ color: "#222", textDecoration: "none", fontWeight: 600 }}>
            +506 2537 3281
          </a>
        </div>
        <div>
          <span>WhatsApp:</span>
          <a
            href="https://wa.me/50687839222"
            target="_blank"
            rel="noopener noreferrer"
            title="WhatsApp"
            style={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
              style={{ width: 22, height: 22, marginRight: 6, verticalAlign: 'middle' }}
            />
            <span style={{ color: '#25D366', fontWeight: 600, fontSize: 16 }}>
              +506 8783 9222
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default ContactUsForm;
